import React from 'react'

export const Boton = (props) => {
  
  return (
    <div>
       
        <div onClick={props.handleClick} 
        
             className={`${props.clicked ? 'abrir2' : 'abrir'}`}>
               <div className="texto-b">{props.clicked ? 'X' : 'APLICAR FILTROS'}</div>
              
        </div>
    </div>
  )
}
